import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { apiRequestHandler } from "../../apiConfig/service";
import { toast } from "react-toastify";

const ForgotPassword2 = () => {
  const [email, setEmail] = useState("");
  const navigate = useNavigate();

  const handleSendOtp = async (e) => {
    e.preventDefault();

    const res = await apiRequestHandler({
      method: "POST",
      endPoint: "forgotPassword",
      data: { email },
    });

    if (res?.success) {
      // Store data required by VerifyOtp
      localStorage.setItem("emailForOtp", email);
      localStorage.setItem("otpSource", "forgotPassword");

      // Set new timer key (used by VerifyOtp)
      const now = Math.floor(Date.now() / 1000);
      const timerDuration = 120; // 2 minutes
      const endTime = now + timerDuration;
      localStorage.setItem("otpTimerEnd", endTime.toString());

      toast.success(res.message);
      navigate("/admin-verify-otp");
    } else {
      toast.error(res?.message || "Something went wrong");
    }
  };

  return (
    <section className="vh-100 bg-light">
      <div className="container h-100">
        <div className="row d-flex align-items-center justify-content-center h-100">
          <div className="col-md-8 col-lg-6 col-xl-5">
            <img
              src="https://mdbcdn.b-cdn.net/img/Photos/new-templates/bootstrap-login-form/draw2.webp"
              className="img-fluid"
              alt="OTP Visual"
            />
          </div>
          <div className="col-md-7 col-lg-5 col-xl-5 offset-xl-1 shadow p-5 bg-white rounded-4">
            <h3 className="text-center mb-4 fw-bold text-primary">Forgot Password</h3>
            <form onSubmit={handleSendOtp}>
              <div className="form-floating mb-4">
                <input
                  type="email"
                  className="form-control"
                  id="floatingEmail"
                  placeholder="Enter your registered email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
                <label htmlFor="floatingEmail">Email address</label>
              </div>
              <button type="submit"                                 className="btn w-100 circle  animation">
                Send OTP
              </button>
              <div className="text-center mt-3">
                                <small className="text-muted">
                                    Back to{" "}
                                    <Link to="/adminlogin" className="text-primary">
                                        login
                                    </Link>
                                </small>
                            </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ForgotPassword2;
